import { combineReducers } from 'redux';

import { createResourceModuleReducerMap, mlRel } from 'medialoopster/rest';

import { DeviceRootState } from './types';

export default combineReducers<DeviceRootState>(
  createResourceModuleReducerMap('device', mlRel('devices')),
);
